import { EFinancingCompany, PlanPromoRule } from '@if/core/types'
import { ApplicableMerchantPaymentPlan } from '@src/data/types/ApplicableMerchantPaymentPlan'
import { DATE_MAX } from '@src/data/types/Constants'
import { Merchant } from '@src/data/types/Merchant'
import { MerchantPaymentPlan } from '@src/data/types/MerchantPaymentPlan'
import MerchantPaymentPlansPanel from './MerchantPaymentPlansPanel'
import MerchantPromoPlanPanel from './MerchantPromoPlanPanel'

interface Props {
  merchant: Merchant
  isPaymentPlanFetching: boolean
  merchantPaymentPlans: MerchantPaymentPlan[]
  merchantPaymentPlansToCreate: ApplicableMerchantPaymentPlan[]
  applicableMerchantPaymentPlans: ApplicableMerchantPaymentPlan[]
  planPromoRules: PlanPromoRule[]
  onMerchantPaymentPlanAdded: (dto: ApplicableMerchantPaymentPlan) => void
}

const MerchantPromotionPanel = ({
  merchant,
  isPaymentPlanFetching,
  merchantPaymentPlans,
  merchantPaymentPlansToCreate,
  applicableMerchantPaymentPlans,
  planPromoRules,
  onMerchantPaymentPlanAdded,
}: Props) => {
  const thereExistsSomeActiveMerchantPaymentPlan = merchantPaymentPlans.some((plan) => {
    const today = new Date()
    const from = new Date(plan.activeFrom)
    const to = new Date(plan.expiresOn ?? DATE_MAX)
    return today >= from && today <= to
  })

  const shouldShowPromotionTab =
    merchant.financingCompanyId === EFinancingCompany.IFinance
      ? !isPaymentPlanFetching && thereExistsSomeActiveMerchantPaymentPlan
      : !isPaymentPlanFetching

  return (
    <>
      {shouldShowPromotionTab && (
        <>
          {merchant.financingCompanyId === EFinancingCompany.Iceberg && (
            <MerchantPaymentPlansPanel
              merchant={merchant}
              merchantPaymentPlans={merchantPaymentPlans}
              merchantPaymentPlansToCreate={merchantPaymentPlansToCreate}
              onMerchantPaymentPlanAdded={onMerchantPaymentPlanAdded}
            />
          )}
          <MerchantPromoPlanPanel
            availablePaymentPlans={applicableMerchantPaymentPlans}
            initialPlanPromoRules={merchant.planPromoRules}
            planPromoRules={planPromoRules}
            supportFinancingPrograms={merchant.supportedFinancingPrograms}
          />
        </>
      )}
    </>
  )
}

export default MerchantPromotionPanel
